<template>
  <div class="product-box rounded elevation-3">
    <v-skeleton-loader
      v-if="loading"
      elevation="3"
      height="200"
      type="image" />
    <div
      v-else
      class="product-content">
      <v-img
        class="rounded"
        :src="$convertImgix(`${imageUrl}`)"
        :lazy-src="$convertImgix(`${lazyImageUrl}`)"
        height="200"
        cover />
      <span class="product-text">
        <!-- {{ splitModel }} -->
        {{ model }}
      </span>
    </div>
    <v-btn
      v-if="removeable && !loading"
      absolute
      color="error"
      icon
      style="top: 4px; right: 4px;"
      @click="$emit('remove', index)">
      <v-icon>
        mdi-close
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import NoPicture from '@/assets/image/no_picture_available.png'

export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    model: {
      type: String,
      default: ''
    },
    photoUrls: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    removeable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imageUrl () {
      return this.photoUrls?.length ? `${this.replaceURL(this.photoUrls[0])}?fm=webp&q=80&h=200` : NoPicture
    },
    lazyImageUrl () {
      return this.photoUrls?.length ? `${this.replaceURL(this.photoUrls[0])}?fm=webp&q=80&w=2&h=2` : NoPicture
    },
    splitModel () {
      const splitted = this.name.split('-')
      return splitted.length ? splitted[splitted.length - 1].trim() : this.name
    }
  },
  methods: {
    replaceURL (value) {
      return value.replace(process.env.VUE_APP_S3_URL, process.env.VUE_APP_S3_IMGIX)
    }
  }
}
</script>

<style scoped>
.product-box {
  position: relative;
  width: 100%;
  height: 200px;
  background-color: #BEBEBE;
  cursor: pointer;
}
.product-content {
  position: relative;
  width: 100%;
  height: 100%;
}
.product-text {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  font-size: 11px;
  text-align: center;
  border-radius: 1rem;
  padding: 0.2rem 0.5rem;
  background-color: rgba(5, 247, 142, 0.7);
}
</style>
